import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import { featuredComics, faqData } from '@/mocks/comics';

export default function Home() {
  const jsonLdWebSite = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "韩漫大全",
    "url": "https://hanmandq.com/",
    "description": "韩漫大全 - 海量韩国漫画免费在线阅读平台",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://hanmandq.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  });

  const jsonLdCollection = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "韩漫大全 - 热门韩国漫画推荐",
    "description": "韩漫大全首页，展示热门推荐、最新更新、排行榜等海量韩国漫画资源",
    "url": "https://hanmandq.com/",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": featuredComics.slice(0, 8).map((comic, i) => ({
        "@type": "ListItem",
        "position": i + 1,
        "item": {
          "@type": "ComicStory",
          "name": comic.title,
          "author": { "@type": "Person", "name": comic.author },
          "url": `https://hanmandq.com/comic/${comic.id}`
        }
      }))
    }
  });

  const jsonLdFAQ = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  });

  return (
    <>
      <title>韩漫大全 - 海量韩国漫画免费在线阅读 | 每日更新</title>
      <meta name="description" content="韩漫大全收录海量正版韩国漫画，涵盖恋爱、悬疑、奇幻、校园等多种类型，每日更新最新章节，支持手机电脑全平台流畅阅读。喜欢韩漫的你，来韩漫大全找到你的专属故事。" />
      <meta name="keywords" content="韩漫大全,韩漫大全免费阅读,韩漫大全最新更新,韩国漫画推荐,热门韩漫排行榜,韩漫在线看,韩漫完结合集" />
      <link rel="canonical" href="https://hanmandq.com/" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdWebSite }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdCollection }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdFAQ }} />
      <HeroSection />
      <CategorySection />
      <FeaturedComics />
      <LatestUpdates />
      <RankingSection />
      <FAQSection />
    </>
  );
}